import { getPaymentPageToken } from '@kikodacode/vbi-cares-api';
import { useQuery } from 'react-query';
import { axiosInstance } from './axiosConfig';
import { queryKeys } from './constants';

export type PaymentPageItem = {
  licenseNumber: string;
  name: string;
  amount: number;
};

export interface usePaymentPageTokenProps {
  items: PaymentPageItem[];
}

export interface PaymentPageTokenResponse {
  token: string;
}

export const usePaymentPageToken = ({ items }: usePaymentPageTokenProps) => {
  const { data, isLoading } = useQuery(
    queryKeys.paymentPageToken(items),
    async (): Promise<PaymentPageTokenResponse> => {
      return (await getPaymentPageToken(items, axiosInstance)).data;
    },
    {
      enabled: items.length > 0,
    },
  );
  return { data, isLoading };
};
